<template>
    <div class="sales-card-news" >
        <div class="sales-card-section-title"><h2>{{ salesCardArr.project_page_in.news_title  }}</h2></div>
        <div class="news-filter">
            <div class="dropwdown-filter-select dropwdown-year">
                <div class="drop-filter-name" :class="{'open' : openYearDrop}">
                    <a href="#" @click.prevent="openYearDrop = !openYearDrop, openPartsDrop = false, openMonthDrop = false" v-if="currentYear != null">{{currentYear}}</a>
                    <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                </div>
                <div class="dropdown-menu" :class="{'open' : openYearDrop}">
                    <div class="drop-checkbox-container">
                        <div class="item-R" v-for="(item, index) in yearsList" :key="index">
                            <input type="radio" :id="'year_' + item" :value="item" v-model="currentYear">
                            <label :for="'year_' + item" @click="buildPartsArrByYear(item), openYearDrop = false">{{item}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dropwdown-filter-select dropwdown-part">
                <div class="drop-filter-name" :class="{'open' : openPartsDrop}">
                    <a href="#" @click.prevent="openPartsDrop = !openPartsDrop, openYearDrop = false, openMonthDrop = false" v-if="currentPart != null">{{getCoorectWordByLang(currentPart.label)}}</a>
                    <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                </div>
                <div class="dropdown-menu" :class="{'open' : openPartsDrop}">
                    <div class="drop-checkbox-container">
                        <div class="item-R" v-for="(item, index) in partsList" :key="index">
                            <input type="radio" :id="'year_' + item.value" :value="item" v-model="currentPart">
                            <label :for="'year_' + item.value" @click="buildMonthArrByPart(item), openPartsDrop = false">{{getCoorectWordByLang(item.label)}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dropwdown-filter-select dropwdown-month">
                <div class="drop-filter-name" :class="{'open' : openMonthDrop}">
                    <a href="#" @click.prevent="openMonthDrop = !openMonthDrop, openYearDrop = false, openPartsDrop = false" v-if="currentMonth != null">
                        <span v-if="globalLang != 'kz/'">{{currentMonth.month.label}}</span>
                        <span v-else>{{getKazakhMonth(currentMonth.month.label)}}</span>
                    </a>
                    <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                </div>
                <div class="dropdown-menu" :class="{'open' : openMonthDrop}">
                    <div class="drop-checkbox-container">
                        <div class="item-R" v-for="(item, index) in monthList" :key="index">
                            <input type="radio" :id="'year_' + item.month.value" :value="item" v-model="currentMonth">
                            <label :for="'year_' + item.month.value" @click="updateNewsSlider(), openMonthDrop = false">
                                <span v-if="globalLang != 'kz/'">{{item.month.label}}</span>
                                <span v-else>{{getKazakhMonth(item.month.label)}}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="news-content-container" v-if="currentPart != null && currentMonth != null">
            <div class="column-container">
                <div class="col-left">
                    <h3>
                        <span class="name">{{salesCardArr.project_name.name}}</span>
                        <span>|</span>
                        <span class="part">{{ getCoorectWordByLang(currentPart.label) }}</span>
                    </h3>
                    <div class="col-desc" v-html="currentMonth.desc"></div>
                </div>
                <div class="col-right">
                    <transition name="fade" mode="out-in">
                        <div class="news-carousel" v-if="newsCarouselInit">
                            <swiper :options="swiperOption" ref="salesNewsCardCarousel" v-if="!isMobileChecker">
                                <swiper-slide v-for="(slide, index) in currentMonth.images" :key="index">
                                    <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                                </swiper-slide>
                            </swiper>
                            <swiper :options="swiperOption" ref="salesNewsCardCarousel" v-if="isMobileChecker">
                                <swiper-slide v-for="(slide, index) in currentMonth.images_mobile" :key="index">
                                    <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                                </swiper-slide>
                            </swiper>
                            <div class="swiper-controls sales-card-news-controls" v-if="currentMonth.images.length > 1">
                                <div class="sales-card-news-btn-prev slider-btn btn-wow-effect-hover">
                                    <svgIcon name="arrow-left" class="icon-left-arrow"/>
                                </div>
                                <div class="sales-card-news-btn-next slider-btn btn-wow-effect-hover">
                                    <svgIcon name="arrow-right" class="icon-right-arrow"/>
                                </div>
                            </div>
                            <div class="swiper-pagination sales-card-news-pagination" v-if="currentMonth.images.length > 1"></div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    import simplebar from 'simplebar-vue';
    import 'simplebar-vue/dist/simplebar.min.css';
    export default {
        name: 'sales-card-news',
        props: ['salesCardArr'],
        components: {
            svgIcon,
            simplebar,
        },
        data () {
            return {
                dataArr: null,
                globalLang: window.GlobalLang, 
                cardArr: null,
                newsCarouselInit: true,
                openYearDrop: false,
                openPartsDrop: false,
                openMonthDrop: false,
                progres_data: null,
                yearsList: [],
                partsList: [],
                monthList: [],
                /// curent data
                currentYear: null,
                currentPart: null,
                currentMonth: null,
                //swiper
                swiperOption: {
                    speed: 1000,
                    observer: true,
                    observeSlideChildren: true,
                    observeParents: true,
                    resizeObserver: true,
                    effect: 'slide',
                    // fadeEffect: {
                    //     crossFade: true
                    // },
                    slidesPerView: 1,
                    simulateTouch: false,
                    watchSlidesVisibility: true,
                    loop: false,
                    navigation: {
                        nextEl: '.sales-card-news-btn-next',
                        prevEl: '.sales-card-news-btn-prev',
                    },
                    pagination: {
                        el: '.sales-card-news-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    breakpoints: {
                        // when window width is >= 900px
                        900: {
                            slidesPerView: 'auto',
                            spaceBetween: 20,
                            simulateTouch: true,
                        },
                    }
                },
            }
        },
        computed: mapGetters({
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            getNewsTimeLine() {
                // console.log(this.salesCardArr, 'asdsad');
                const ID = this.salesCardArr.project_page_in.news_progres;
                axios.get(window.url + window.GlobalLang + window.JsonUrl + 'sales-news/' + ID).then(async (response) => {
                    // console.log(response.data.acf.news_progres, 'FILTER CMS PARAMS');
                    this.progres_data = response.data.acf.news_progres;
                    this.yearsList = this.progres_data
                    .map(i => parseInt(i.year))
                    .filter(Boolean);

                    // уникальные
                    this.uniqueElementsInArray(this.yearsList);

                    // ✅ сортировка по убыванию (последний год первым)
                    this.yearsList.sort((a,b) => b - a);

                    // ✅ выбираем самый свежий год
                    this.buildPartsArrByYear(this.yearsList[0]);
                });
            },
            buildPartsArrByYear(year) {
                this.currentYear = year;
                var defaultData = this.progres_data;
                var filteredParts = defaultData.filter(item => {
                    return parseInt(item.year) == year
                });
                this.partsList = [];
                for (var i=0; i < filteredParts.length; i++) {
                    this.partsList.push(filteredParts[i].ochered);
                }
                this.buildMonthArrByPart(this.partsList[0]);
            }, 
            buildMonthArrByPart(part) {
                this.currentPart = part;
                var defaultData = this.progres_data;
                var filteredMonth = defaultData.filter(item => {
                    return parseInt(item.year) == this.currentYear &&
                           item.ochered.value == part.value
                });
                // console.log(defaultData, filteredMonth, 'asdasdsad')
                this.monthList = filteredMonth[0].month_info;
                this.currentMonth = this.monthList[0];
            },
            updateNewsSlider() {
                this.newsCarouselInit = false;
                setTimeout(() => {
                    this.newsCarouselInit = true;
                }, 350);
            },
            uniqueElementsInArray(arr) {
                function onlyUnique(value, index, array) {
                    return array.indexOf(value) === index;
                }
                this.yearsList = arr.filter(onlyUnique);
            },  
            getCoorectWordByLang(str) {
                if (this.globalLang != 'kz/') {
                    return str
                } else {
                    const num = parseInt(str.match(/\d+/)[0]);
                    const word = ' кезек';
                    return num + word;
                }
            },
            getKazakhMonth(monthNameRu) {
                const monthNames = {
                    '01': { kz: 'Қаңтар', default: 'Января' },
                    '02': { kz: 'Ақпан', default: 'Февраля' },
                    '03': { kz: 'Наурыз', default: 'Марта' },
                    '04': { kz: 'Сәуiр', default: 'Апреля' },
                    '05': { kz: 'Мамыр', default: 'Мая' },
                    '06': { kz: 'Маусым', default: 'Июня' },
                    '07': { kz: 'Шiлде', default: 'Июля' },
                    '08': { kz: 'Тамыз', default: 'Августа' },
                    '09': { kz: 'Қыркүйек', default: 'Сентября' },
                    '10': { kz: 'Қазан', default: 'Октября' },
                    '11': { kz: 'Қараша', default: 'Ноября' },
                    '12': { kz: 'Желтоқсан', default: 'Декабря' }
                };

                const ruToKey = {
                    'Январь': '01', 'Января': '01',
                    'Февраль': '02', 'Февраля': '02',
                    'Март': '03', 'Марта': '03',
                    'Апрель': '04', 'Апреля': '04',
                    'Май': '05', 'Мая': '05',
                    'Июнь': '06', 'Июня': '06',
                    'Июль': '07', 'Июля': '07',
                    'Август': '08', 'Августа': '08',
                    'Сентябрь': '09', 'Сентября': '09',
                    'Октябрь': '10', 'Октября': '10',
                    'Ноябрь': '11', 'Ноября': '11',
                    'Декабрь': '12', 'Декабря': '12'
                };
                const key = ruToKey[monthNameRu.trim()];
                if (!key) return monthNameRu;
                return monthNames[key].kz;
            }
            // uniqueElementsInArray(arr) {
            //     let result = [];
            //     for (let str of arr) {
            //         if (!result.includes(str)) {
            //             result.push(str);
            //         }
            //     }
            //     return result;
            // },
        },
        beforeCreate() {
        },
        created () {
            this.getNewsTimeLine();
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales-card/sales-card-news.scss';
    @import '@/styles/components/sales-card/respond/sales-card-news-respond.scss';
</style>